import {AiFillStar} from 'react-icons/ai';
import {permColors} from '../../utils/colors';

const testimonials = [
	{
		imageSrc: '/images/testimonials/charbs.png',
		altText: 'Charbel',
		name: 'Charbel A',
		title: 'Founder @ Propertied',
		testimonial: 'Being our first time hiring a virtual staff member, we relied heavily on Permworks job board to guide us through the process. Engaging with Permworks was a great success.',
		timeToPlacement: '1.5 weeks',
	},
	{
		imageSrc: '/images/testimonials/recr.png',
		altText: 'Emma',
		name: 'Emma H',
		title: 'Founder @ Shoestring Services',
		testimonial: 'We have been extremely impressed with Permworks job board. It has made the process of growing our team with high quality talent a breeze.',
		timeToPlacement: '1 weeks',
	},
	{
		imageSrc: '/images/testimonials/andrew_ze.jpg',
		altText: 'Andrew Zetterholm',
		name: 'Andrew Zetterholm',
		title: 'CEO @ Megarhino',
		testimonial: 'Absolutely smooth process from beginning to end.',
		timeToPlacement: '3 weeks',
	},
	{
		imageSrc: '/images/testimonials/andrew_zo.jpg',
		altText: 'Andrew Zoghbi',
		name: 'Andrew Zoghbi',
		title: 'Partner @ Kelly Partners',
		testimonial: 'The Permworks platform was very user friendly and helped us recruit new team members super quick. Highly recommended and will continue to use in the future.',
		timeToPlacement: '2 week',
	},
];

export default function Testimonials() {
	return (
		<div className="my-20">
			<div className="mx-auto flex flex-col items-center justify-center gap-10 w-[1500px] max-w-full">
				<h2 className="font-normal text-2xl text-darkCharcoal">100's of Happy Clients</h2>
				<div className="snap-x flex text-left gap-5 p-2.5 max-w-full overflow-x-auto scrollbar-thin scrollbar-track-backgroundGrey scrollbar-thumb-linkBlue hover:scrollbar-thumb-deepBlue">
					{testimonials.map((testimonial, index) => (
						<div key={index} className="shadow-sm rounded-lg min-w-[260px] w-[260px] mobile-width-100 snap-center bg-backgroundModern" >
							<img src={testimonial.imageSrc} alt={testimonial.altText} className="w-full h-[200px] object-cover rounded-t-lg" />
							<div className="flex flex-col gap-2.5 p-5">
								<h3 className="text-base font-semibold">{testimonial.name}</h3>
								<h4 className="text-sm text-charcoal font-light">{testimonial.title}</h4>
								<p className="text-sm" style={{color: permColors.darkCharcoal}}>
									Time to placement:<strong> {testimonial.timeToPlacement}</strong>
								</p>
								<div className="flex text-amber-500 text-base">
									<AiFillStar />
									<AiFillStar />
									<AiFillStar />
									<AiFillStar />
									<AiFillStar />
								</div>
								<p className="text-sm" style={{color: permColors.darkCharcoal}}>
									{testimonial.testimonial}
								</p>
							</div>
						</div>
					))}
				</div>
			</div>
			<br />
			<br />
			<br />
		</div>
	);
}
